import { lazy } from 'react';

// we suggest the use of lazy to load containers

// replace this code with your own containers
// const getComponent1 = lazy(() => import('containers/Sample/Container1'));
const getPayment = lazy(() => import('containers/Payment'));
const getSummary = lazy(() => import('containers/Summary'));
const getInvoices = lazy(() => import('containers/Invoices'));

export const billingLandingRoutes = {
  SUMMARY: {
    path: '/landing/summary',
    name: 'Summary',
    getComponent: getSummary,
  },
  INVOICES: {
    path: '/landing/invoices',
    name: 'Invoices',
    getComponent: getInvoices,
  },
  PAYMENT: {
    path: '/landing/payment',
    name: 'Payment',
    getComponent: getPayment,
  },
};
